import React from 'react'
import { useSelector } from 'react-redux'

import PatientDetailsHeader from '~/components/dashboard/soapV2/summary/patient-details/PatientDetailsHeader'
import { PatientMedicalSummaryRail } from '~/components/dashboard/soapV2/summary/PatientMedicalSummaryRail'
import { getConversationById } from '~/store/reducers/conversations'
import { getPatient } from '~/store/reducers/patients'
import { getUser } from '~/store/reducers/users'

import { CommunicationsHeaderMenuButton } from './CommunicationsHeaderMenuButton'

import styles from './CommunicationsPatientMedicalRecordRightRail.module.scss'

interface CommunicationsPatientMedicalRecordRightRailProps {
  conversationId: string
}

export const CommunicationsPatientMedicalRecordRightRail = ({
  conversationId,
}: CommunicationsPatientMedicalRecordRightRailProps) => {
  const conversation = useSelector(getConversationById(conversationId))
  const clientId = conversation?.client ?? ''
  const patientId = conversation?.patient ?? ''

  const patient = useSelector(getPatient(patientId))
  const client = useSelector(getUser(clientId))

  if (!clientId || !patientId || !patient || !client || !conversation) {
    return null
  }

  return (
    <div className={styles.rightRailContainer}>
      <div className={styles.patientDetailsHeader}>
        <PatientDetailsHeader
          actionsSlot={
            <CommunicationsHeaderMenuButton conversation={conversation} />
          }
          clientId={clientId}
          patient={patient}
        />
      </div>

      <PatientMedicalSummaryRail clientId={clientId} patientId={patientId} />
    </div>
  )
}

export default CommunicationsPatientMedicalRecordRightRail
